import { ServiceLayout } from "@/components/service/ServiceLayout";
import { ServiceFAQ } from "@/components/service/ServiceFAQ";
import { HeroSection } from "@/components/ai-agents/HeroSection";
import { CapabilitiesSection } from "@/components/ai-agents/CapabilitiesSection";
import { UseCasesSection } from "@/components/ai-agents/UseCasesSection";
import { DemoSection } from "@/components/ai-agents/DemoSection";
import { ServiceCTA } from "@/components/ui/ServiceCTA";
import { serviceFAQs } from "@/data/service-faqs";

const AIAgents = () => {
  return (
    <ServiceLayout serviceName="AI Agents" className="bg-gradient-to-b from-blue-50 to-white">
      <HeroSection />
      <CapabilitiesSection />
      <UseCasesSection />
      <DemoSection />
      <ServiceFAQ faqs={serviceFAQs["ai-agents"]} serviceName="AI Agents" />
      <ServiceCTA serviceName="AI Agents" />
    </ServiceLayout>
  );
};

export default AIAgents;